import { render, staticRenderFns } from "./create_item_sale.vue?vue&type=template&id=7173dbd7&scoped=true"
import script from "./create_item_sale.vue?vue&type=script&lang=js"
export * from "./create_item_sale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7173dbd7",
  null
  
)

export default component.exports